import { Button, Input, message } from "antd";
import { InputProps } from "antd/lib/input";
import React, { FC, useMemo, useState } from "react";
import _t from "../../lang/translate";
import { getRemoteData, getVinDetails } from "../../services/vehicleService";
import { RemoteVehicleData, VinVehicle } from "../../types/appTypes";
import { isAxiosError } from "../../utilities/typeGuard";
import { isValidVin } from "../../utilities/stringExtraFunctions";
import Icon from "../../assets/icons/icon";
import PopoverList from "../popups/popoverList";

type InputVinProps = InputProps & ({
  searchText?: string | null;
  withAliasCreate?: boolean;
}) & ({
  useRemoteVehicleData?: false;
  onFetched?: ((data: VinVehicle) => void) | null | false;
} | {
  useRemoteVehicleData: true;
  onFetched?: ((data: RemoteVehicleData) => void) | null | false;
})
function fixVin(vin: unknown) {
  if (typeof vin !== 'string') return ''
  return vin.toUpperCase().replaceAll("O", "0")
}

const InputVin: FC<InputVinProps> = ({ value, onFetched, useRemoteVehicleData, searchText, withAliasCreate, disabled, ...rest }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validVin = useMemo(() => isValidVin(value), [value]);
  const vinLength = typeof value === 'string' ? value.length : 0;
  const fetchVinData = async () => {
    setLoading(true);
    try {
      if (useRemoteVehicleData) {
        const vin = value as string;
        const { data } = await getRemoteData({ items: ["dat", "dmr"], vin });
        onFetched && onFetched(data.data);
      } else {
        const { data } = await getVinDetails(value as string);
        onFetched && onFetched(data);

      }
    } catch (error) {
      const errorMessage = isAxiosError(error) ? error.response?.data?.message : null;
      message.error(errorMessage || _t("msg.unknown_error"));
    } finally {
      setLoading(false);
    }
  };

  let nextProps: InputProps = {
    value: fixVin(value?.toString()),
    maxLength: 90,
    disabled,
    ...rest,
  };

  if (onFetched) {
    nextProps = {
      ...nextProps,
      disabled: disabled || loading,
      className: "input-group-btn",
      addonAfter: (
        <Button onClick={fetchVinData} disabled={!validVin || disabled} loading={loading} type="ghost">
          {searchText || _t("DMR")}
        </Button>
      ),
    };
  } else {
    nextProps = {
      ...nextProps,
      suffix: validVin ? (
        <Icon name="checkmark-circle-outline" className="text-blue" size="medium" />
      ) : (
        <PopoverList list={[
          _t("msg.vin_invalid"),
          _t("msg.vin_required_length") + " " + _t("vin") + " " + _t("is").toLowerCase() + " " + vinLength + " " + _t('characters').toLowerCase(),
          _t("msg.vin_required_characters")
        ]}>
          <Icon name="alert-circle-outline" className="text-warning" size="medium" />
        </PopoverList>
      ),
    };
  }


  return (
    <Input {...nextProps} />
  );
};

export default InputVin;
